import React from "react";
import { BRAND, LOGO_WHITE_URL } from "../../data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#050505] border-t border-white/10 py-12">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        <img src={LOGO_WHITE_URL} alt="Rock Chicks Productions" className="h-12 w-auto" draggable={false} />
        <span className="font-display font-semibold uppercase tracking-[0.35em] text-[11px] text-white/70 border-l border-white/20 pl-3">
          Productions
        </span>
      </div>
      <p className="text-sm text-gray-500 font-light">
        {BRAND.owner} · {BRAND.location}
      </p>
      <p className="text-xs text-gray-600">
        © {new Date().getFullYear()} {BRAND.name}
      </p>
    </div>
    <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-8 pt-6 border-t border-white/10 text-center">
      <p className="text-xs text-gray-500">
        Built by{" "}
        <a
          data-testid="footer-boost-link"
          href="https://boostmarketing.agency/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-[#b533ff] font-medium transition-colors duration-300"
        >
          Boost! Design &amp; Marketing
        </a>
      </p>
    </div>
  </footer>
);
